import { render, staticRenderFns } from "./NoMatchList.vue?vue&type=template&id=72774626&scoped=true&"
import script from "./NoMatchList.vue?vue&type=script&lang=js&"
export * from "./NoMatchList.vue?vue&type=script&lang=js&"
import style0 from "./NoMatchList.vue?vue&type=style&index=0&id=72774626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72774626",
  null
  
)

export default component.exports